__turbopack_context__.v({
  "logo": "GalleryModal-module__ujKy5W__logo",
  "logo_close": "GalleryModal-module__ujKy5W__logo_close",
  "modal": "GalleryModal-module__ujKy5W__modal",
  "modal__closeBtn": "GalleryModal-module__ujKy5W__modal__closeBtn",
  "nav": "GalleryModal-module__ujKy5W__nav",
  "swiper_bottom": "GalleryModal-module__ujKy5W__swiper_bottom",
  "swiper_bottom__section": "GalleryModal-module__ujKy5W__swiper_bottom__section",
  "swiper_buttons": "GalleryModal-module__ujKy5W__swiper_buttons",
  "swiper_buttons__prev": "GalleryModal-module__ujKy5W__swiper_buttons__prev",
  "viewer": "GalleryModal-module__ujKy5W__viewer",
  "viewer__swiper": "GalleryModal-module__ujKy5W__viewer__swiper",
  "viewer__swiper__slide": "GalleryModal-module__ujKy5W__viewer__swiper__slide",
  "viewer__swiper__slide__title": "GalleryModal-module__ujKy5W__viewer__swiper__slide__title",
  "viewer__swiper__video": "GalleryModal-module__ujKy5W__viewer__swiper__video",
});
